import { useFlags } from 'launchdarkly-react-client-sdk';
import { ffDefaults } from '~/constants/featureFlagDefaults';
import { useUserFeatureFlagsSync } from './useUserFeatureFlagsSync';

/**
 * Hook to access Launch Darkly feature flags
 *
 */
export const useFeatureFlags = () => {
  const ldFlags = useFlags<typeof ffDefaults>();
  const { loading } = useUserFeatureFlagsSync();

  const flags = {
    ...ffDefaults,
    ...ldFlags,
  };

  return { flags, loading };
};
